import { helper } from '@ember/component/helper';
import { fromJSDate as timeFromJSDate } from 'my-phorest/utils/local-time-helpers';

export function timeFromJSDateParse([date] /*, hash*/) {
  return timeFromJSDate(date);
}

export default helper(timeFromJSDateParse);
